<mat-tab-group>
    <mat-tab style="border:solid 1px black" label="Identity Documents">
        <div class="clearfix clearfixuserdoc" style="background-color: #bbb;">
            <ul class="udocul">
                <li class="udocli datefield">&nbsp;</li>
                <li class="udocli titlefield">PAN</li>
                <li class="udocli buttonfield">
                    <input type="button" value="View Document" class="appButtonudoc appButton" style="float: right; margin: 5px; " (click)="onViewDocument(owner.ownerinformation.pandoc, owner.name +  ' - PAN')">
                </li>
            </ul>
        </div>

        <div class="clearfix clearfixuserdoc" style="background-color: #bbb;">
            <ul class="udocul">
                <li class="udocli datefield">&nbsp;</li>
                <li class="udocli titlefield">AADHAAR</li>
                <li class="udocli buttonfield">
                    <input type="button" value="View Document" class="appButtonudoc appButton" style="float: right; margin: 5px; " (click)="onViewDocument(owner.ownerinformation.aadhardoc, owner.name +  ' AADHAAR')">
                </li>
            </ul>
        </div>

        <div [hidden]="!owner.ownerinformation.rationcarddoc != undefined" class="clearfix clearfixuserdoc" style="background-color: #bbb;">
            <ul class="udocul">
                <li  class="udocli datefield">&nbsp;</li>
                <li  class="udocli titlefield">Ration Card</li>
                <li class="budocli uttonfield">
                    <input type="button" value="View Document" class="appButtonudoc appButton" style="float: right; margin: 5px; " (click)="onViewDocument(owner.ownerinformation.rationcarddoc, owner.name +  ' Ration Card')">
                </li>
            </ul>
        </div>


        <div [hidden]="!owner.ownerinformation.passportdoc != undefined" class="clearfix clearfixuserdoc" style="background-color: #bbb;">
            <ul class="udocul">
                <li  class="udocli datefield">&nbsp;</li>
                <li class="tudocli itlefield">Passport</li>
                <li class="budocli uttonfield">
                    <input type="button" value="View Document" class="appButtonudoc appButton" style="float: right; margin: 5px; " (click)="onViewDocument(owner.ownerinformation.passportdoc, owner.name +  ' Passport')">
                </li>
            </ul>
        </div>


    </mat-tab>
    <mat-tab label="Bank & Other Documents">
        <div *ngFor="let doc of owner.otherdocuments" class="clearfix clearfixuserdoc" style="background-color: #bbb;">
            <ul class="udocul">
                <li class="udocli datefield">&nbsp;</li>
                <li class="udocli titlefield">{{doc.title}}</li>
                <li class="udocli buttonfield">
                    <input type="button" value="View Document" class="appButtonudoc appButton" style="float: right; margin: 5px; " (click)="onViewDocument(doc, owner.name + ' - ' + doc.title)">
                </li>
            </ul>
        </div>

    </mat-tab>n
    <mat-tab label="Income Tax Return(ITR)">
        <div *ngFor="let doc of owner.taxreturns" class="clearfix clearfixuserdoc" style="background-color: #bbb;">
            <ul class="udocul">
                <li class="udocli datefield">&nbsp;</li>
                <li class="udocli titlefield">{{doc.returnyear}}</li>
                <li class="udocli buttonfield">
                    <input type="button" value="View Document" class="appButtonudoc appButton" style="float: right; margin: 5px; " (click)="onViewDocument(doc, owner.name + ' - ' + doc.title)">
                </li>
            </ul>
        </div>

    </mat-tab>
    <mat-tab label="Annual Filings">
        <div *ngFor="let doc of owner.annualreturns" class="clearfix clearfixuserdoc" style="background-color: #bbb;">
            <ul class="udocul">
                <li class="udocli datefield">{{doc.year}}</li>
                <li class="udocli titlefield">{{doc.category}}</li>
                <li class="udocli buttonfield">
                    <input type="button" value="View Document" class="appButtonudoc appButton" style="float: right; margin: 5px; " (click)="onViewDocument(doc, owner.name + ' - ' + doc.title)">
                </li>
            </ul>
        </div>

    </mat-tab>
</mat-tab-group>


